const root = 'https://docs.wandb.ai';

// Use this directly if you know the name of the docUrl you want.
const DOC_URLS = {
  root,
  config: root + '/library/config',
  logs: root + '/guides/track/log',
  save: root + '/guides/track/save-restore',
  started: root + '/quickstart',
  examples: 'https://github.com/wandb/examples',
  gettingStarted: root + '/quickstart',
  loggingObjects: root + '/guides/track/log',
  summaryMetric: root + '/guides/track/log#summary-metrics',
  api: root + '/library/api',
  audio: root + '/guides/track/log/media#other-media',
  images: root + '/guides/track/log/media#images',
  video: root + '/guides/track/log/media#other-media',
  table: root + '/guides/track/log/log-tables',
  object3D: root + '/guides/track/log/media#3d-visualizations',
  molecule: root + '/guides/track/log/media#3d-visualizations',
  html: root + '/guides/track/log/media#other-media',
  plotly: root + '/guides/track/log/plots',
  'weave-projector':
    root + '/guides/app/features/panels/weave/embedding-projector',
  'weave-plot': root + '/guides/app/features/panels/weave',
  'weave-table': root + '/guides/data-vis/tables-quickstart',
  reports: root + '/reports',
  sweeps: root + '/sweeps',
  artifacts: root + '/artifacts',
  artifactsMetadata: root + '/artifacts/api#updating-artifacts',
  compareMetrics: root + '/app/features/panels/compare-metrics/reference',
  customCharts: root + '/app/features/custom-charts',
  limits: root + '/library/advanced/limits',
  codeSaving: root + '/app/features/panels/code',
  codeComparer: root + '/app/features/panels/code#code-comparer',
  pythonApi: root + '/library/api',
  parameterImportance:
    root + '/guides/app/features/panels/parameter-importance',
  integrations: root + '/guides/integrations',
  fileExport: root + '/library/public-api-guide#download-all-files-from-a-run',
  teams: root + '/guides/app/features/teams',
  teamTrials: root + '/guides/app/features/teams#team-trials',
  publicApi: root + '/ref/python/public-api',
  workspaces: root + '/guides/app/pages/workspaces',
  defineMetric: root + '/guides/track/log#customize-the-summary',
  weave: root + '/guides/app/features/panels/weave',
  launch: root + '/guides/launch',
  createQueue: root + '/guides/launch/create-queue',
  modelManagement: root + '/guides/models/',
};

// Use this if you need an index lookup
export function lookupDocUrl(name: string) {
  return (DOC_URLS as {[key: string]: string | undefined})[name];
}

export default DOC_URLS;
